import React from 'react';
import Utils from '../utils/utils';

export default class Price extends React.Component {
  _itemTotal() {
    let total = parseFloat(this.props.price);
    return Math.abs(total);
  }

  render() {
    return (
      <span className="price">
        {Utils.getCurrencySymbol(this.props.currency)}{this._itemTotal().toFixed(2)}
        {!this.props.skipCurrency && <span className="small currency">{this.props.currency}</span>}
      </span>
    );
  }
};
